import _find from 'lodash/find';
import _get from 'lodash/get';

export default (value, meta, key = 'name') => {
  const item = _find(meta, (el) => el.id === value);

  return _get(item, key, value);
};
